<template>
  <div class="blog-home-page">
    <SiteHeader/>

    <section class="blog-highlights-section">
      <v-container class="pt-16 pb-4">
        <h2 class="blog-grid-heading mb-4">{{ $t('home.blogHighlights') }}</h2>
        <div class="blog-bento-grid">
          <div class="blog-bento-cell blog-bento-cell--big">
            <BlogPostCard :post="highlightPosts[0]" size="bento" large/>
          </div>
          <div class="blog-bento-cell blog-bento-cell--top">
            <BlogPostCard :post="highlightPosts[1]" size="bento"/>
          </div>
          <div class="blog-bento-cell blog-bento-cell--mid">
            <BlogPostCard :post="highlightPosts[2]" size="bento"/>
          </div>
          <div class="blog-bento-cell blog-bento-cell--bottom">
            <BlogPostCard :post="highlightPosts[3]" size="bento"/>
          </div>
        </div>
      </v-container>
    </section>

    <section class="blog-grid-section">
      <v-container class="pb-16">
        <h2 class="blog-grid-heading">{{ $t('home.blogRecentPosts') }}</h2>
        <v-row class="mt-2">
          <v-col v-for="post in gridPosts" :key="post.slug" cols="12" sm="6" md="4">
            <BlogPostCard :post="post" size="grid"/>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <SiteFooter/>
  </div>
</template>

<script>
import SiteHeader from "../fragments/SiteHeader.vue";
import SiteFooter from "../fragments/SiteFooter.vue";
import BlogPostCard from "../fragments/BlogPostCard.vue";

export default {
  name: 'BlogHome',
  components: {
    SiteHeader,
    SiteFooter,
    BlogPostCard,
  },
  computed: {
    allPosts: function() {
      return this.$t('blogPosts')
    },
    sortedPosts: function() {
      return this.allPosts.slice().sort((a, b) => {
        if (a.date !== b.date) return b.date.localeCompare(a.date)
        return (b.featured ? 1 : 0) - (a.featured ? 1 : 0)
      })
    },
    highlightPosts: function() {
      return this.sortedPosts.slice(0, 4)
    },
    gridPosts: function() {
      return this.sortedPosts.slice(4)
    },
  },
}
</script>

<style scoped>
.blog-home-page {
  font-family: 'Montserrat', sans-serif;
  background: #F7F5EF;
  padding-top: 72px;
}
.blog-grid-heading {
  font-weight: 900;
  font-size: 1.5rem;
  color: #101827;
  margin: 0;
}
.blog-bento-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  grid-template-rows: 10.5rem 10.5rem 11rem;
  grid-template-areas:
    "big top"
    "big mid"
    "bottom bottom";
  gap: 1rem;
}
.blog-bento-cell {
  border-radius: 1.25rem;
  overflow: hidden;
}
.blog-bento-cell--big {
  grid-area: big;
}
.blog-bento-cell--top {
  grid-area: top;
}
.blog-bento-cell--mid {
  grid-area: mid;
}
.blog-bento-cell--bottom {
  grid-area: bottom;
}
@media (max-width: 959px) {
  .blog-bento-grid {
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-template-areas:
      "big"
      "top"
      "mid"
      "bottom";
  }
}
</style>
